import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  padding: 8px 2px;
  border-bottom: 1.5px solid #d2d2d7;
  margin-bottom: 40px;
  transition: border-color 0.2s;
  &:focus-within {
    border-color: #007aff;
  }
`;

const Container = styled.input`
  background-color: transparent;
  width: 400px;
  font-family: inherit;
  font-weight: 500;
  font-size: 17px;
  outline: none;
  border: none;
  color: #1d1d1f;
  ::placeholder {
    color: #86868b;
  }
`;

const Input = ({ type, name, value, placeholder, onChange }) => {
  return (
    <Wrapper>
      <Container type={type} name={name} value={value} onChange={onChange} placeholder={placeholder || "내용을 입력해주세요."} />
    </Wrapper>
  );
};

export default Input;